import React from 'react'

import { NavLink } from 'react-router-dom'
import { EllipsisVertical } from 'lucide-react';
import MovingText from './movingText';
import { useAuth } from '../teacher/AuthContext';


const Header = () => {
  const { currentUser, logout, loading } = useAuth();
  if (loading) {
      return <div className="loading-spacer"></div>; // Prevents "flicker"
  }

return(
    <header className='bg-white/70 shadow-lg backdrop-blur-sm fixed w-full justify-items-stretch z-50'>
     <div className="  flex h-12 justify-between items-center gap-4">
    
    <NavLink to="/" className="text-3xl font-bold"><h3>TRi<span>ANf</span></h3></NavLink>
         
       {/*<input type="text" placeholder="Search"/>*/}   
        <MovingText  />
        {/*<NavLink to="/threedots" className='mr-4'><EllipsisVertical/></NavLink>*/}  
         
        {/*<div onClick={toggleLoginPopup}>*/}
        {/* CONDITIONAL AUTH SECTION*/} 
        {window.currentUser ? (
          <div className=" inline-block ml-20">
            <NavLink to="/profile" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-[#fbc901] hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }>
              Hi, {currentUser.email.split('@')[0]}
            </NavLink>
        <button 
              onClick={logout} 
             className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-[#fbc901] hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
            ><strong>
              Logout
            </strong></button>
          </div>
          ) : (
          <NavLink to="/login" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-[#fbc901] hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }><strong>
            Login
          </strong></NavLink>
        )}
      
        
        
       {/*<NavLink to="/login#log" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Login</NavLink>
        <NavLink to="/join" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Membership</NavLink>*/}
     

        
       
    </div>
    </header>

  )
}

export default Header;
